export default {
  PUSH_RISK_ALERTS: 'PUSH_RISK_ALERTS',
  SET_RISK_ALERTS_IS_LOADING: 'SET_RISK_ALERTS_IS_LOADING'
};
